import {html, css, CSSResultGroup, TemplateResult} from 'lit'
import {customElement} from 'lit/decorators.js'
import {BaseComponent} from './base-component.js'

@customElement('il-price-tag')
export default class PriceTagComponent extends BaseComponent {
  static override styles: CSSResultGroup = [
    BaseComponent.styles,
    css`
      .il-product-price-tag {
        padding: 1px 6px;
        border-radius: 4px;
        border: 1px solid var(--il-color-accent-100);
        background: var(--il-color-accent-50);

        color: var(--il-color-accent-400);
        font-size: var(--il-font-size-14);
        font-weight: var(--il-font-weight-bold);
        line-height: var(--il-font-line-height-140);
        letter-spacing: var(--il-font-letter-spacing-2);
      }

      .il-product-price-tag ::slotted([part='small']) {
        font-size: var(--il-font-size-12);
        font-weight: var(--il-font-weight-normal);
        line-height: var(--il-font-line-height-150);
        letter-spacing: var(--il-font-letter-spacing-1);
      }
    `,
  ]

  override render (): TemplateResult {
    return html`
      <div
        class="${this.baseCSSClass} il-product-price-tag"
        data-test-iliad-price-tag
      >
        <slot></slot>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'il-price-tag': PriceTagComponent
  }
}
